// import { initializeApp, getApps } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { getFirestore } from "firebase/firestore";

// //=================PRODUÇÃO===========================
// const firebaseConfig = {
  
//   apiKey: "AIzaSyAa2VcDYw6RKNiRbXsny6Q5WgA7KdhOulU",
//   authDomain: "erp-maxtramidia.firebaseapp.com",
//   projectId: "erp-maxtramidia",
//   storageBucket: "erp-maxtramidia.firebasestorage.app",
//   messagingSenderId: "863430282442",
//   appId: "1:863430282442:web:7b11eea795a3e4985df833",
//   measurementId: "G-Y8LEWLF93H"
// };

// // =================HOMOLOGAÇÃO===========================
// // const firebaseConfig = {
// //   apiKey: "AIzaSyBbEHpl3fdMflivmg8cIkdxnHwWvxUVsJI",
// //   authDomain: "homologacao-maxtramidia.firebaseapp.com",
// //   projectId: "homologacao-maxtramidia",
// //   storageBucket: "homologacao-maxtramidia.firebasestorage.app",
// //   messagingSenderId: "1046394778226",
// //   appId: "1:1046394778226:web:6069ca47c7b2ff51b808eb",
// //   measurementId: "G-HF9R1X72TH"
// // };

// // Initialize Firebase

// const app = initializeApp(firebaseConfig);

// const auth = getAuth(app);
// // const auth = getAuth(appAdm);
// const db = getFirestore(app);

// export {db, auth}


import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Produção (ADM) – usado para login
const firebaseConfigAdm = {
  apiKey: "AIzaSyAa2VcDYw6RKNiRbXsny6Q5WgA7KdhOulU",
  authDomain: "erp-maxtramidia.firebaseapp.com",
  projectId: "erp-maxtramidia",
  storageBucket: "erp-maxtramidia.firebasestorage.app",
  messagingSenderId: "863430282442",
  appId: "1:863430282442:web:7b11eea795a3e4985df833",
  measurementId: "G-Y8LEWLF93H"
};

// Inicializa (ou reaproveita) o app ADM com nome 'adm'
const appAdm = getApps().find(app => app.name === 'adm') || initializeApp(firebaseConfigAdm, 'adm');

const auth = getAuth(appAdm);
const db = getFirestore(appAdm);

export { auth, db, appAdm };
